import { render, staticRenderFns } from "./payg-change-plan.vue?vue&type=template&id=4a60abc5&"
import script from "./payg-change-plan.vue?vue&type=script&lang=js&"
export * from "./payg-change-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports